import { AnalyticsProtoEvents } from './analyticsScreenNames';

export function createClickAnalyticsPayload(clickName: ClickEventType, clickValue: string) {
    return {
        AnalyticsEvent: AnalyticsProtoEvents.click,
        eventType: AnalyticsProtoEvents.click,
        [AnalyticsProtoEvents.click]: {
            clickName: clickName,
            clickType: 'general_click',
            generalClick: {
                clickValue: {
                    value: clickValue,
                },
            },
        },
    };
}

export function createDeepLinkClickPayload({
    link,
    name,
    id,
    index,
    startDateMs,
    endDateMs,
    eventType,
}: {
    link: string;
    name: string;
    id: string;
    index: number;
    startDateMs: number;
    endDateMs: number;
    eventType: ClickEventType;
}) {
    return {
        AnalyticsEvent: AnalyticsProtoEvents.click,
        eventType: AnalyticsProtoEvents.click,
        [AnalyticsProtoEvents.click]: {
            clickName: eventType,
            clickType: 'deep_link_click',
            deepLinkClick: {
                productType: 1,
                deepLink: { value: link },
                deepLinkTitle: { value: name.toLowerCase() },
                contentId: { value: id },
                position: { value: index },
                startTime: {
                    seconds: Math.floor(startDateMs / 1000),
                    nanos: Math.floor(startDateMs % 1000 * 1000000),
                },
                endTime: {
                    seconds: Math.floor(endDateMs / 1000),
                    nanos: Math.floor(endDateMs % 1000 * 1000000),
                },
            },
        },
    };
}

export const ClickEventType = {
    clickNameUnspecified: 0,
    marketFilterOptions: 1,
    marketFilterClick: 2,
    homeNewsClick: 3,
    footerClick: 4,
    hotTournamentsClick: 5,
    matchDetailsClick: 6,
    homeQuickLinkClick: 7,
    homeBannerClick: 8,
    multimediaStartClick: 9,
    multimediaCloseClick: 10,
    marketGroupSearchClick: 16,
    marketGroupClick: 17,
    loyaltyRafEntrypointClick: 18,
    loyaltyRafMainScreenClick: 19,
    loyaltyRafCodeVerificationClick: 20,
    loyaltyRafManualAwardingClick: 96,
    favouriteMarketGroupClick: 45,
    collapseMarketGroupClick: 46,
    marketGroupBetInfoClick: 47,
    marketGroupOptionChangeClick: 48,
    homepageSportSwitcherClick: 59,
    homepageSportSwitcherLiveEventsClick: 76,
    popularAccumulatorsTakeClick: 83,
    offerMarketSuperAdvantageIconClick: 85,
    ticketMarketSuperAdvantageIconClick: 86,
    tournamentHeaderSuperAdvantageIconClick: 87,
    offerExpandAllMarkets: 91,
    offerCollapseAllMarkets: 92,
    prematchEventsFilter: 93,
    sportsCalendarDateClick: 99,
    popularAccumulatorsAddMoreSelectionsClick: 104,
    popularAccumulatorsRemoveClick: 105,
    liveEventsFilterClick: 106,
    liveEventsSortByClick: 107,
    liveEventsSortSelected: 108,
    liveEventsFilterXClick: 109,
    topWinnersAddToBetslip: 113,
    topWinnersExpandSelections: 114,
    popularAccasAddMoreClearClick: 117,
    popularAccasAddMoreTakeClick: 118,
} as const;

export type ClickEventType = typeof ClickEventType[keyof typeof ClickEventType];

export const TestClickEventTypes = {
    marketGroupSearchContent: 'market_group_search_content',
    feedPersonalizationMatchDetailsClick: 'feed_personalisation_match_details_click',
    feedPersonalizationAddToBetslip: 'feed_personalisation_add_to_betslip',
    eventDetailsLoadResult: 'event_details_load_result',
} as const;
